'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResolvedAttachments = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getResolvedAttachments = exports.getResolvedAttachments = (0, _get2.default)('resolvedAttachments');


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/selectors/getResolvedAttachments.js
// module id = 603
// module chunks = 2 3